export default "__VITE_ASSET__BYVZL5jM__"